import React from "react";
import PropTypes from "prop-types";
import { IconButton, InputBase, Paper } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

/**
 * @component  SearchInputComp
 * @description Reusable Search input field component for form
 * @returns Search Component UI
 */
function SearchInputComp(props) {
  return (
    <div className="searchInputForm">
      {/* E5 design: 340 x 48 box, grey border, purple search icon on the right */}
      <Paper
        component="form"
        onSubmit={(e) => e.preventDefault()}
        sx={{
          display: "flex",
          alignItems: "center",
          width: 260,
          maxWidth: "100%",
          height: 34,
          boxSizing: "border-box",
          border: "1px solid #ccc",
          borderRadius: "8px",
          boxShadow: "none",
          backgroundColor: "#fff",
          pl: "12px",
          pr: "8px",
        }}
      >
        <InputBase
          sx={{
            flex: 1,
            fontSize: 13,
            "& input": { font: "inherit !important", fontSize: "13px !important", p: 0 },
            "& input::placeholder": { color: "#999", opacity: 1 },
          }}
          placeholder={props.placeholderText}
          onChange={props.handleChange}
          inputProps={{ maxLength: 50, "aria-label": props.placeholderText }}
          onKeyPress={(e) => {
            e.key === "Enter" && e.preventDefault();
          }}
        />

        <IconButton sx={{ p: "8px", color: "#864797" }} aria-label="search" disabled>
          <FontAwesomeIcon icon={faSearch} style={{ color: "#864797", fontSize: 13 }} />
        </IconButton>
      </Paper>
    </div>
  );
}

SearchInputComp.propTypes = {
  handleChange: PropTypes.func,
  placeholderText: PropTypes.string,
};

export default SearchInputComp;
